$bog_vmap_app_palette_port $mol_form_field
	sign \
	body \
	owner \
	needle \
	name <= sign
	bids / <= owner
	control <= Body $mol_dimmer
		haystack <= body
		needle <= needle
